export const snakeToCamel = str => str.replace(/([-_]\w)/g, group => group[1].toUpperCase())

export const camelToSnake = str => str.replace(/[A-Z]/g, group => `_${group.toLowerCase()}`)
